import { Action, createReducer, on } from '@ngrx/store';

import { LoadingState, Logout } from '@personal-area/global/state';

import { ABTestConfig } from '../../models/ab-test';
import { ProfileVariant } from '../../models/profile-variant.dto';
import { GetTests, GetTestsFail, GetTestsSuccess } from '../actions/ab-test';

export interface ABTestState {
  tests: ProfileVariant[];
  config: ABTestConfig;
  loadingState: LoadingState;
}

const initialState: ABTestState = {
  tests: [],
  config: {},
  loadingState: LoadingState.initial,
};

const _reducer = createReducer(
  initialState,
  on(GetTests, (state) => ({
    ...state,
    loadingState: LoadingState.loading,
  })),
  on(GetTestsSuccess, (_, { response }) => ({
    tests: response.variants,
    config: response.config as ABTestConfig,
    loadingState: LoadingState.loaded,
  })),
  on(GetTestsFail, (state) => ({
    ...state,
    loadingState: LoadingState.failed,
  })),
  on(Logout, (state) => initialState),
);

export const abTestReducer = (state: ABTestState | undefined, action: Action) =>
  _reducer(state, action);
